import React, { useEffect, useState } from 'react';
import { Table, Button } from 'antd';
import { FormOutlined } from '@ant-design/icons';
import ApiServices from '~services';
import Utils from '~commons/utils';
import { InfoCarInspection } from './inforCarInspection';
import { FormUpdateCarInspection } from './form-update';
import CarInspectionFields from './fields-data';
import { DisplayFilesSimple } from '~components/display-files-simple';
import { TableTitle } from '~commons/styles';

const CarInspections = ({ id }) => {
  const [infoCarInspection, setInfoCarInspection] = useState({});
  const [inspectionList, setInspectionList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isShowFormUpdate, setIsShowFormUpdate] = useState(false);
  const [fields, setFields] = useState({});
  const [isNew, setIsNew] = useState(false);
  const [dataCarInspection, setDataCarInspection] = useState({});

  const getCarInspections = async () => {
    try {
      setLoading(true);
      let { data } = await ApiServices.getCarInspection(id);
      setLoading(false);
      if (data) {
        const datainspectionList =
          data.inspectionList.data.map((item, index) => {
            item.index = index;
            return item;
          }) || [];
        setInfoCarInspection(data.infoCar);
        setInspectionList(datainspectionList);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getCarInspections();
    setIsShowFormUpdate(false);
  }, [id]);

  const setFieldsForm = async (value) => {
    const carInspectionFields = await CarInspectionFields(value);
    await setFields(carInspectionFields);
    return carInspectionFields;
  };

  const isShowFormUpdateFn = async () => {
    await setFieldsForm({}).then(() => {
      setIsNew(true);
      setIsShowFormUpdate(true);
    });
  };

  const onRowSelected = async (value) => {
    const _value = {
      ...value,
      inspectionDateNew: Utils.convertToDate(value.inspectionDateNew),
      inspectionExpirationDateNew: Utils.convertToDate(value.inspectionExpirationDateNew),
      files: value?.orderFiles,
    };
    await setFieldsForm(_value).then(() => {
      setIsNew(false);
      setDataCarInspection(value);
      setIsShowFormUpdate(true);
    });
  };

  const columns = [
    {
      title: 'Số KĐ Cũ',
      dataIndex: 'inspectionNumberOld',
      width: 100,
      render: (value, record) => {
        if (record?.index === 0) {
          return <a onClick={() => onRowSelected(record)}>{value ? value : <FormOutlined />}</a>;
        } else {
          return <span>{value}</span>;
        }
      },
    },
    {
      title: 'Ngày KĐ Cũ',
      dataIndex: 'inspectionDateOld',
      width: 130,
      render: (value) => Utils.formatDate(value),
    },
    {
      title: 'Ngày HHKĐ Cũ',
      dataIndex: 'inspectionExpirationDateOld',
      width: 130,
      render: (value) => Utils.formatDate(value),
    },
    {
      title: 'Chi Phí KĐ Cũ',
      dataIndex: 'inspectionCostOld',
      width: 130,
    },
    {
      title: 'Số KĐ Mới',
      dataIndex: 'inspectionNumberNew',
      width: 100,
    },
    {
      title: 'Ngày KĐ Mới',
      dataIndex: 'inspectionDateNew',
      width: 130,
      render: (value) => Utils.formatDate(value),
    },
    {
      title: 'Ngày HHKĐ Mới',
      dataIndex: 'inspectionExpirationDateNew',
      width: 130,
      render: (value) => Utils.formatDate(value),
    },
    {
      title: 'Chi Phí KĐ Mới',
      dataIndex: 'inspectionCostNew',
      width: 130,
    },
    {
      title: <TableTitle>File Đính kèm</TableTitle>,
      dataIndex: 'orderFiles',
      width: 150,
      render: (val) => <DisplayFilesSimple files={val} />,
    },
    {
      title: 'Ghi Chú',
      dataIndex: 'note',
      width: 100,
    },
  ];

  return (
    <>
      {isShowFormUpdate ? (
        <FormUpdateCarInspection
          setIsShowFormUpdate={setIsShowFormUpdate}
          fields={fields}
          onChange={(newFields) => {
            setFields(newFields);
          }}
          idCar={id}
          getCarInspections={getCarInspections}
          isNew={isNew}
          dataCarInspection={dataCarInspection}
          setLoading={setLoading}
        />
      ) : (
        <>
          <InfoCarInspection infoCarInspection={infoCarInspection} />
          <Button type='primary' className='mg-b-10 mg-t-10' onClick={isShowFormUpdateFn}>
            Thêm Mới
          </Button>
        </>
      )}

      <Table
        rowKey='id'
        bordered
        loading={loading}
        dataSource={inspectionList}
        columns={columns}
        scroll={{ x: 1000, y: 300 }}
      />
    </>
  );
};

export { CarInspections };
